import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/shipRecord',
    meta: { title: '发货记录' },
    component: Layout,
    redirect: '/shipRecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '发货记录', activeMenu: '/shipRecord' },
        component: () => import('@/views/shipRecord/ShipRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '发货记录详情', activeMenu: '/shipRecord' },
        component: () => import('@/views/shipRecord/ShipRecordDetail.vue')
      }
    ]
  }
]
